(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gg-scrubber-price"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('gg-review-trigger')){
customElements.define('gg-review-trigger',class extends HTMLElement{
connectedCallback(){this.handler=(event)=>{const dialog=document.getElementById('gg-review-dialog');if(dialog){event.preventDefault();dialog.showModal();}};this.addEventListener('click',this.handler);}
disconnectedCallback(){this.removeEventListener('click',this.handler);}
});}
  } catch(e) { console.error(e); }
})();

})();
